import { Icon } from '@chakra-ui/react';

export default function SFUnlockIcon(props) {
  return (
    <Icon
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M5.719 19.82c-1.149 0-1.758-.625-1.758-1.86v-5.382c0-1.226.61-1.851 1.758-1.851h6.39v-1.86c0-2.937 1.914-4.36 3.961-4.36 2.04 0 3.97 1.423 3.97 4.36v1.57c0 .485-.282.696-.618.696-.352 0-.625-.235-.625-.695V8.703c0-1.976-1.266-3.015-2.727-3.015s-2.726 1.039-2.726 3.015v2.063c.836.156 1.281.765 1.281 1.812v5.383c0 1.234-.61 1.86-1.758 1.86zm.039-1.18h7.07c.344 0 .531-.21.531-.593v-5.555c0-.383-.187-.586-.53-.586H5.757c-.336 0-.531.203-.531.586v5.555c0 .383.195.594.53.594' />
    </Icon>
  );
}
